/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Indemnification_Item_1Inputs */

const es_tyc_indemnification_item_1 = /** @type {(inputs: Tyc_Indemnification_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Su incumplimiento de estos Terminos.`)
};

const en_tyc_indemnification_item_1 = /** @type {(inputs: Tyc_Indemnification_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your breach of these Terms.`)
};

/**
* | output |
* | --- |
* | "Your breach of these Terms." |
*
* @param {Tyc_Indemnification_Item_1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_indemnification_item_1 = /** @type {((inputs?: Tyc_Indemnification_Item_1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Indemnification_Item_1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_indemnification_item_1(inputs)
	return en_tyc_indemnification_item_1(inputs)
});
export { tyc_indemnification_item_1 as "tyc.indemnification.item_1" }